/**
 * Created by Julio Perez on 9/20/2016.
 */

import angular from 'angular';
import uirouter from 'angular-ui-router';
// import ngAnimate from 'angular-animate';

////ROUTING
import routing from './app.routes';

////COMPONENTS
import appView from './app-view';
import headerSection from './views/header-section';
import footerSection from './views/footer-section';
import mapPage from './views/map-page';
import navLinksStrip from './ui/nav-links-strip';


////REQUIRED: for bootstrap/jquery/LESS/font-awesome

require('expose?$!expose?L!leaflet');
require('expose?$!expose?jQuery!jquery');
require('bootstrap-webpack');
require('./shared/style/style.less');
require('font-awesome/css/font-awesome.css');
require('leaflet');
require('leaflet-providers');
require('leaflet-image');
require('./shared/js/L.D3SvgOverlay');
require('./shared/style/L.Control.MousePosition.css');
require('./shared/js/L.Control.MousePosition');

require('iframe-resizer');
require('numeral');


var app = angular
    .module('app',[
        uirouter,
        appView,
        headerSection,
        footerSection,
        mapPage,
        navLinksStrip
    ])
    .config(routing);

export default app;



// WEBPACK FOOTER //
// ./src/app/app.js